import React from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Card, Button, TextField, Snackbar, Alert, Backdrop, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import CustomersTable from "./components/CustomersTable";
import useCustomers from "features/customers/hooks/useCustomers";

function Customers() {
  const navigate = useNavigate();

  const {
    customers,
    searchValue,
    setSearchValue,
    currentPage,
    totalPages,
    loading,
    error,
    success,
    handlePageChange,
    handleStatusToggle,
    resetAlerts,
    setCurrentPage,
  } = useCustomers();

  const handleSearchChange = (event) => {
    setCurrentPage(1);
    setSearchValue(event.target.value);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Customers
                </MDTypography>
              </MDBox>
              <MDBox pt={1} px={1}>
                <MDBox
                  pt={1}
                  px={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  gap={2}
                >
                  <TextField
                    label="Search"
                    variant="outlined"
                    margin="normal"
                    placeholder="Search by name, email, phone"
                    style={{ maxWidth: 360, width: "100%" }}
                    value={searchValue}
                    onChange={handleSearchChange}
                  />
                </MDBox>
                <CustomersTable
                  rows={customers}
                  onToggleStatus={handleStatusToggle}
                  detailClick={(id) => navigate(`/dashboard/customers/details/${id}`)}
                />

                <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
                  <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                    Previous
                  </Button>
                  <MDTypography mx={2}>Page {currentPage} of {totalPages}</MDTypography>
                  <Button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    Next
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={!!error || !!success}
        autoHideDuration={3000}
        onClose={resetAlerts}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={resetAlerts} severity={error ? "error" : "success"} sx={{ width: "100%" }}>
          {error || success}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default Customers;
